export default __webpack_public_path__ + "static/media/kitchen3-after3-480w.0aa7c146.png";